const webModule = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
};

export default webModule;
